import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingTop: 30,
    paddingBottom: 60,
  },
  heading: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    textTransform: "uppercase",
    paddingBottom: 20,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "transparent",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#403E92",
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
    backgroundColor: "#403E92",
    color: "white",
  },
  tableCol: {
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
    textAlign: "center",
  },
  tableCell: {
    fontSize: 8,
  },
  footer: {
    position: "absolute",
    bottom: -20,
    left: 0,
    right: 0,
    textAlign: "right",
    fontSize: 8,
  },
});

const CustomerPdf = ({ data = [] }) => (
  <Document title={"Customer List"}>
    <Page size="A4" style={styles.page} orientation="landscape">
      <View style={styles.heading}>
        <Text>Customer List</Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow} fixed>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Tin</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Customer</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Company</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Phone</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Email</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Country</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Type</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCell}>Status</Text>
          </View>
        </View>
        {data && data.length > 0 ? (
          data.map((row, idx) => (
            <View
              key={row.customer_id || idx}
              style={styles.tableRow}
              wrap={false}
            >
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.tin || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.first_name && row.last_name
                    ? `${row.first_name} ${row.last_name}`
                    : "--"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.company_name || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.mobile_no || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.email || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{row.country || "--"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.type === "individual" ? "Individual" : "Company"}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {row.status === true ? "Active" : "Inactive"}
                </Text>
              </View>
            </View>
          ))
        ) : (
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>No data</Text>
            </View>
          </View>
        )}
      </View>
      <View fixed>
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
        />
      </View>
    </Page>
  </Document>
);

export default CustomerPdf;
